import styled, { keyframes } from "styled-components";
import { GrayColors } from "@smartsuite/types";

const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// A plain, non-interactive bordered box. Used for informational condition
// labels that carry no expandable content -- the block-level "no branch
// conditions met" message and the else branch's "when no conditions are met"
// label (which, unlike a real branch, has no condition list to expand).
export const StyledStaticBox = styled.div`
  padding: 10px 15px;
  background-color: ${GrayColors["G-0"]};
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 8px;
  word-break: break-word;
`;

export const StyledConditionLine = styled.div`
  display: flex;
  gap: 4px;
`;

export const StyledBranchContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  animation: ${fadeSlideIn} 180ms ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

// Softens the skeleton -> content swap of a lazily-fetched box that appears
// after its parent's own enter animation already ran.
export const StyledFadeIn = styled.div`
  animation: ${fadeSlideIn} 180ms ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
